export enum ShiftMatchStatusEnums {
  ERROR = 0, // ShiftMatchFlags.ExceptionErr = 0x00040 |  SM.Exeption.enumExceptionNumber =15
  WARNING = 1, // ShiftMatchFlags.Exception = 0x00020
  ABSENCE = 2, // ShiftMatchFlags.AbsenceScheduled = 0x01000
  WORKED = 3, // No icon / status (i.e. default status)
  DAILY_SIGNED_OFF = 4, // ShiftMatchFlags.ExceptionChecked = 0x00010
  LOCKED = 5, // No corresponding shift match flags
  INACTIVE = 6, // Inactive
}
